import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "htmlFor", "for", "elementType", "onClick"],
  _excluded2 = ["label", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "validationState", "description", "errorMessage", "isDisabled", "showErrorIcon", "contextualHelp", "children", "labelProps", "descriptionProps", "errorMessageProps", "elementType", "wrapperClassName", "wrapperProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { useStyleProps as $6WzO6$useStyleProps, classNames as $6WzO6$classNames, SlotProvider as $6WzO6$SlotProvider, useDOMRef as $6WzO6$useDOMRef } from "@react-spectrum/utils";
import { Flex as $6WzO6$Flex } from "@react-spectrum/layout";
import { useId as $6WzO6$useId, mergeProps as $6WzO6$mergeProps, mergeRefs as $6WzO6$mergeRefs, filterDOMProps as $6WzO6$filterDOMProps } from "@react-aria/utils";
import $6WzO6$react, { useCallback as $6WzO6$useCallback } from "react";
import { useFormProps as $6WzO6$useFormProps } from "@react-spectrum/form";
import $6WzO6$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $6WzO6$spectrumiconsuiAsterisk from "@spectrum-icons/ui/Asterisk";
import { useLocalizedStringFormatter as $6WzO6$useLocalizedStringFormatter } from "@react-aria/i18n";
import { useProviderProps as $6WzO6$useProviderProps } from "@react-spectrum/provider";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $beda4304297005df$exports = {};
$parcel$export($beda4304297005df$exports, "spectrum-HelpText", function () {
  return $beda4304297005df$export$c0875e83c57c7736;
}, function (v) {
  return $beda4304297005df$export$c0875e83c57c7736 = v;
});
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-validationIcon", function () {
  return $beda4304297005df$export$527776642b333691;
}, function (v) {
  return $beda4304297005df$export$527776642b333691 = v;
});
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-text", function () {
  return $beda4304297005df$export$a512452beb4231bf;
}, function (v) {
  return $beda4304297005df$export$a512452beb4231bf = v;
});
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--neutral", function () {
  return $beda4304297005df$export$6e9351b1ad13c;
}, function (v) {
  return $beda4304297005df$export$6e9351b1ad13c = v;
});
$parcel$export($beda4304297005df$exports, "is-disabled", function () {
  return $beda4304297005df$export$d35bc1e505d1ebbf;
}, function (v) {
  return $beda4304297005df$export$d35bc1e505d1ebbf = v;
});
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--negative", function () {
  return $beda4304297005df$export$d31dd875d69daee0;
}, function (v) {
  return $beda4304297005df$export$d31dd875d69daee0 = v;
});
var $beda4304297005df$export$c0875e83c57c7736;
var $beda4304297005df$export$527776642b333691;
var $beda4304297005df$export$a512452beb4231bf;
var $beda4304297005df$export$6e9351b1ad13c;
var $beda4304297005df$export$d35bc1e505d1ebbf;
var $beda4304297005df$export$d31dd875d69daee0;
$beda4304297005df$export$c0875e83c57c7736 = "spectrum-HelpText_f395de";
$beda4304297005df$export$527776642b333691 = "spectrum-HelpText-validationIcon_f395de";
$beda4304297005df$export$a512452beb4231bf = "spectrum-HelpText-text_f395de";
$beda4304297005df$export$6e9351b1ad13c = "spectrum-HelpText--neutral_f395de";
$beda4304297005df$export$d35bc1e505d1ebbf = "is-disabled_f395de";
$beda4304297005df$export$d31dd875d69daee0 = "spectrum-HelpText--negative_f395de";
function $8e50676506611310$var$HelpText(props, ref) {
  var description = props.description,
    errorMessage = props.errorMessage,
    validationState = props.validationState,
    isDisabled = props.isDisabled,
    showErrorIcon = props.showErrorIcon,
    descriptionProps = props.descriptionProps,
    errorMessageProps = props.errorMessageProps;
  var domRef = $6WzO6$useDOMRef(ref);
  var isErrorMessage = errorMessage && validationState === 'invalid';
  var _$6WzO6$useStyleProps = $6WzO6$useStyleProps(props),
    styleProps = _$6WzO6$useStyleProps.styleProps;
  return /*#__PURE__*/$6WzO6$react.createElement("div", _objectSpread(_objectSpread({}, styleProps), {}, {
    className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports), 'spectrum-HelpText', "spectrum-HelpText--".concat(isErrorMessage ? 'negative' : 'neutral'), {
      'is-disabled': isDisabled
    }, styleProps.className),
    ref: domRef
  }), isErrorMessage ? /*#__PURE__*/$6WzO6$react.createElement($6WzO6$react.Fragment, null, showErrorIcon && /*#__PURE__*/$6WzO6$react.createElement($6WzO6$spectrumiconsuiAlertMedium, {
    UNSAFE_className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports), 'spectrum-HelpText-validationIcon')
  }), /*#__PURE__*/$6WzO6$react.createElement("div", _objectSpread(_objectSpread({}, errorMessageProps), {}, {
    className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports), 'spectrum-HelpText-text')
  }), errorMessage)) : /*#__PURE__*/$6WzO6$react.createElement("div", _objectSpread(_objectSpread({}, descriptionProps), {}, {
    className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports), 'spectrum-HelpText-text')
  }), description));
}
/**
 * Help text provides either an informative description or an error message that gives more context about what a user needs to input. It's commonly used in forms.
 */
var $8e50676506611310$export$a67c0bc59081311a = /*#__PURE__*/$6WzO6$react.forwardRef($8e50676506611310$var$HelpText);
var $79b4ff1b6ea94ffc$exports = {};
var $dfe96401c0c81db3$exports = {};
$dfe96401c0c81db3$exports = {
  "(optional)": "(\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
  "(required)": "(\u0645\u0637\u0644\u0648\u0628)"
};
var $f504605657ece833$exports = {};
$f504605657ece833$exports = {
  "(optional)": "(\u043D\u0435\u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E)",
  "(required)": "(\u0437\u0430\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E)"
};
var $ed0ab9e7c53f9351$exports = {};
$ed0ab9e7c53f9351$exports = {
  "(optional)": "(voliteln\u011B)",
  "(required)": "(po\u017Eadov\xE1no)"
};
var $59d9df99e04ee555$exports = {};
$59d9df99e04ee555$exports = {
  "(optional)": "(valgfrit)",
  "(required)": "(obligatorisk)"
};
var $c5df0169c370d169$exports = {};
$c5df0169c370d169$exports = {
  "(optional)": "(optional)",
  "(required)": "(erforderlich)"
};
var $3c9af509a01a8d08$exports = {};
$3c9af509a01a8d08$exports = {
  "(optional)": "(\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
  "(required)": "(\u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9)"
};
var $aa36476f91664a08$exports = {};
$aa36476f91664a08$exports = {
  "(required)": "(required)",
  "(optional)": "(optional)"
};
var $d96f2251ced25e45$exports = {};
$d96f2251ced25e45$exports = {
  "(optional)": "(opcional)",
  "(required)": "(necesario)"
};
var $16ec4ffbd4b2ca4b$exports = {};
$16ec4ffbd4b2ca4b$exports = {
  "(optional)": "(valikuline)",
  "(required)": "(n\xF5utav)"
};
var $60f372f660e937e4$exports = {};
$60f372f660e937e4$exports = {
  "(optional)": "(valinnainen)",
  "(required)": "(pakollinen)"
};
var $d87c5f1e899f6af1$exports = {};
$d87c5f1e899f6af1$exports = {
  "(optional)": "(facultatif)",
  "(required)": "(requis)"
};
var $6899669fa63c7816$exports = {};
$6899669fa63c7816$exports = {
  "(optional)": "(\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9)",
  "(required)": "(\u05E0\u05D3\u05E8\u05E9)"
};
var $3597d722a30a8081$exports = {};
$3597d722a30a8081$exports = {
  "(optional)": "(opcionalno)",
  "(required)": "(obvezno)"
};
var $3ef905a2ce0921cb$exports = {};
$3ef905a2ce0921cb$exports = {
  "(optional)": "(opcion\xE1lis)",
  "(required)": "(k\xF6telez\u0151)"
};
var $e59d2e4af9ff1c28$exports = {};
$e59d2e4af9ff1c28$exports = {
  "(optional)": "(facoltativo)",
  "(required)": "(obbligatorio)"
};
var $422a7013ab2cb36d$exports = {};
$422a7013ab2cb36d$exports = {
  "(optional)": "\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09",
  "(required)": "\uFF08\u5FC5\u9808\uFF09"
};
var $a58a7ab9570c5a18$exports = {};
$a58a7ab9570c5a18$exports = {
  "(optional)": "(\uC120\uD0DD \uC0AC\uD56D)",
  "(required)": "(\uD544\uC218 \uC0AC\uD56D)"
};
var $24e660c5a5be82af$exports = {};
$24e660c5a5be82af$exports = {
  "(optional)": "(pasirenkama)",
  "(required)": "(privaloma)"
};
var $a222e05de6d8dce8$exports = {};
$a222e05de6d8dce8$exports = {
  "(optional)": "(neoblig\u0101ti)",
  "(required)": "(oblig\u0101ti)"
};
var $524caea23ab94ad7$exports = {};
$524caea23ab94ad7$exports = {
  "(optional)": "(valgfritt)",
  "(required)": "(obligatorisk)"
};
var $572079ed86210ca9$exports = {};
$572079ed86210ca9$exports = {
  "(optional)": "(optioneel)",
  "(required)": "(vereist)"
};
var $6a0777ee77a74b18$exports = {};
$6a0777ee77a74b18$exports = {
  "(optional)": "(opcjonalne)",
  "(required)": "(wymagane)"
};
var $ea0401974d81b469$exports = {};
$ea0401974d81b469$exports = {
  "(optional)": "(opcional)",
  "(required)": "(obrigat\xF3rio)"
};
var $701d0854e4f18979$exports = {};
$701d0854e4f18979$exports = {
  "(optional)": "(opcional)",
  "(required)": "(obrigat\xF3rio)"
};
var $dd9fccd10d0a4be3$exports = {};
$dd9fccd10d0a4be3$exports = {
  "(optional)": "(op\u0163ional)",
  "(required)": "(obligatoriu)"
};
var $3cd1eab3b0ecc980$exports = {};
$3cd1eab3b0ecc980$exports = {
  "(optional)": "(\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E)",
  "(required)": "(\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)"
};
var $d109f3d68ba24ffc$exports = {};
$d109f3d68ba24ffc$exports = {
  "(optional)": "(nepovinn\xE9)",
  "(required)": "(povinn\xE9)"
};
var $6382c2117e9fd1b6$exports = {};
$6382c2117e9fd1b6$exports = {
  "(optional)": "(opcijsko)",
  "(required)": "(obvezno)"
};
var $ba796dd79114e2d4$exports = {};
$ba796dd79114e2d4$exports = {
  "(optional)": "(opciono)",
  "(required)": "(obavezno)"
};
var $916521e9800ac46c$exports = {};
$916521e9800ac46c$exports = {
  "(optional)": "(valfritt)",
  "(required)": "(kr\xE4vs)"
};
var $acd72b88f580fe64$exports = {};
$acd72b88f580fe64$exports = {
  "(optional)": "(iste\u011Fe ba\u011Fl\u0131)",
  "(required)": "(gerekli)"
};
var $bd065904f1420f31$exports = {};
$bd065904f1420f31$exports = {
  "(optional)": "(\u043D\u0435\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)",
  "(required)": "(\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)"
};
var $0128cc194bc107bb$exports = {};
$0128cc194bc107bb$exports = {
  "(optional)": "\uFF08\u53EF\u9009\uFF09",
  "(required)": "\uFF08\u5FC5\u586B\uFF09"
};
var $c57738f6094a3d25$exports = {};
$c57738f6094a3d25$exports = {
  "(optional)": "(\u9078\u586B)",
  "(required)": "(\u5FC5\u586B)"
};
$79b4ff1b6ea94ffc$exports = {
  "ar-AE": $dfe96401c0c81db3$exports,
  "bg-BG": $f504605657ece833$exports,
  "cs-CZ": $ed0ab9e7c53f9351$exports,
  "da-DK": $59d9df99e04ee555$exports,
  "de-DE": $c5df0169c370d169$exports,
  "el-GR": $3c9af509a01a8d08$exports,
  "en-US": $aa36476f91664a08$exports,
  "es-ES": $d96f2251ced25e45$exports,
  "et-EE": $16ec4ffbd4b2ca4b$exports,
  "fi-FI": $60f372f660e937e4$exports,
  "fr-FR": $d87c5f1e899f6af1$exports,
  "he-IL": $6899669fa63c7816$exports,
  "hr-HR": $3597d722a30a8081$exports,
  "hu-HU": $3ef905a2ce0921cb$exports,
  "it-IT": $e59d2e4af9ff1c28$exports,
  "ja-JP": $422a7013ab2cb36d$exports,
  "ko-KR": $a58a7ab9570c5a18$exports,
  "lt-LT": $24e660c5a5be82af$exports,
  "lv-LV": $a222e05de6d8dce8$exports,
  "nb-NO": $524caea23ab94ad7$exports,
  "nl-NL": $572079ed86210ca9$exports,
  "pl-PL": $6a0777ee77a74b18$exports,
  "pt-BR": $ea0401974d81b469$exports,
  "pt-PT": $701d0854e4f18979$exports,
  "ro-RO": $dd9fccd10d0a4be3$exports,
  "ru-RU": $3cd1eab3b0ecc980$exports,
  "sk-SK": $d109f3d68ba24ffc$exports,
  "sl-SI": $6382c2117e9fd1b6$exports,
  "sr-SP": $ba796dd79114e2d4$exports,
  "sv-SE": $916521e9800ac46c$exports,
  "tr-TR": $acd72b88f580fe64$exports,
  "uk-UA": $bd065904f1420f31$exports,
  "zh-CN": $0128cc194bc107bb$exports,
  "zh-TW": $c57738f6094a3d25$exports
};
var $cd231e464c886c86$exports = {};
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel", function () {
  return $cd231e464c886c86$export$493d18e796ae054;
}, function (v) {
  return $cd231e464c886c86$export$493d18e796ae054 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--positionSide", function () {
  return $cd231e464c886c86$export$9e6f19dc21f22f2e;
}, function (v) {
  return $cd231e464c886c86$export$9e6f19dc21f22f2e = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel-requiredIcon", function () {
  return $cd231e464c886c86$export$7c47642c7d46f3c9;
}, function (v) {
  return $cd231e464c886c86$export$7c47642c7d46f3c9 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--alignEnd", function () {
  return $cd231e464c886c86$export$885efcc08143a987;
}, function (v) {
  return $cd231e464c886c86$export$885efcc08143a987 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field", function () {
  return $cd231e464c886c86$export$f6d480ae1e56eba0;
}, function (v) {
  return $cd231e464c886c86$export$f6d480ae1e56eba0 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionTop", function () {
  return $cd231e464c886c86$export$a4ea780a9064d7f9;
}, function (v) {
  return $cd231e464c886c86$export$a4ea780a9064d7f9 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-field", function () {
  return $cd231e464c886c86$export$3ab8a3dc7f0563d;
}, function (v) {
  return $cd231e464c886c86$export$3ab8a3dc7f0563d = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--alignEnd", function () {
  return $cd231e464c886c86$export$5354c9be7ada5f83;
}, function (v) {
  return $cd231e464c886c86$export$5354c9be7ada5f83 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionSide", function () {
  return $cd231e464c886c86$export$2963225c91179589;
}, function (v) {
  return $cd231e464c886c86$export$2963225c91179589 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-wrapper", function () {
  return $cd231e464c886c86$export$127df0b7290eb8ef;
}, function (v) {
  return $cd231e464c886c86$export$127df0b7290eb8ef = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-contextualHelp", function () {
  return $cd231e464c886c86$export$24fb860d16dd2d3f;
}, function (v) {
  return $cd231e464c886c86$export$24fb860d16dd2d3f = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--hasContextualHelp", function () {
  return $cd231e464c886c86$export$9ba23707a252cdd4;
}, function (v) {
  return $cd231e464c886c86$export$9ba23707a252cdd4 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form", function () {
  return $cd231e464c886c86$export$94d2bcc94afabd89;
}, function (v) {
  return $cd231e464c886c86$export$94d2bcc94afabd89 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionSide", function () {
  return $cd231e464c886c86$export$7f44db659563c8f4;
}, function (v) {
  return $cd231e464c886c86$export$7f44db659563c8f4 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelCell", function () {
  return $cd231e464c886c86$export$9cde5aecff012641;
}, function (v) {
  return $cd231e464c886c86$export$9cde5aecff012641 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelWrapper", function () {
  return $cd231e464c886c86$export$a872a8c78b26c9e0;
}, function (v) {
  return $cd231e464c886c86$export$a872a8c78b26c9e0 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionTop", function () {
  return $cd231e464c886c86$export$11b8bc81fe551057;
}, function (v) {
  return $cd231e464c886c86$export$11b8bc81fe551057 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-LabeledValue", function () {
  return $cd231e464c886c86$export$79f9a5e9dd010c8d;
}, function (v) {
  return $cd231e464c886c86$export$79f9a5e9dd010c8d = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form-itemLabel", function () {
  return $cd231e464c886c86$export$51ec27881a1e3928;
}, function (v) {
  return $cd231e464c886c86$export$51ec27881a1e3928 = v;
});
$parcel$export($cd231e464c886c86$exports, "is-disabled", function () {
  return $cd231e464c886c86$export$d35bc1e505d1ebbf;
}, function (v) {
  return $cd231e464c886c86$export$d35bc1e505d1ebbf = v;
});
var $cd231e464c886c86$export$493d18e796ae054;
var $cd231e464c886c86$export$9e6f19dc21f22f2e;
var $cd231e464c886c86$export$7c47642c7d46f3c9;
var $cd231e464c886c86$export$885efcc08143a987;
var $cd231e464c886c86$export$f6d480ae1e56eba0;
var $cd231e464c886c86$export$a4ea780a9064d7f9;
var $cd231e464c886c86$export$3ab8a3dc7f0563d;
var $cd231e464c886c86$export$5354c9be7ada5f83;
var $cd231e464c886c86$export$2963225c91179589;
var $cd231e464c886c86$export$127df0b7290eb8ef;
var $cd231e464c886c86$export$24fb860d16dd2d3f;
var $cd231e464c886c86$export$9ba23707a252cdd4;
var $cd231e464c886c86$export$94d2bcc94afabd89;
var $cd231e464c886c86$export$7f44db659563c8f4;
var $cd231e464c886c86$export$9cde5aecff012641;
var $cd231e464c886c86$export$a872a8c78b26c9e0;
var $cd231e464c886c86$export$11b8bc81fe551057;
var $cd231e464c886c86$export$79f9a5e9dd010c8d;
var $cd231e464c886c86$export$51ec27881a1e3928;
var $cd231e464c886c86$export$d35bc1e505d1ebbf;
$cd231e464c886c86$export$493d18e796ae054 = "spectrum-FieldLabel_d2db1f";
$cd231e464c886c86$export$9e6f19dc21f22f2e = "spectrum-FieldLabel--positionSide_d2db1f";
$cd231e464c886c86$export$7c47642c7d46f3c9 = "spectrum-FieldLabel-requiredIcon_d2db1f";
$cd231e464c886c86$export$885efcc08143a987 = "spectrum-FieldLabel--alignEnd_d2db1f";
$cd231e464c886c86$export$f6d480ae1e56eba0 = "spectrum-Field_d2db1f";
$cd231e464c886c86$export$a4ea780a9064d7f9 = "spectrum-Field--positionTop_d2db1f";
$cd231e464c886c86$export$3ab8a3dc7f0563d = "spectrum-Field-field_d2db1f";
$cd231e464c886c86$export$5354c9be7ada5f83 = "spectrum-Field--alignEnd_d2db1f";
$cd231e464c886c86$export$2963225c91179589 = "spectrum-Field--positionSide_d2db1f";
$cd231e464c886c86$export$127df0b7290eb8ef = "spectrum-Field-wrapper_d2db1f";
$cd231e464c886c86$export$24fb860d16dd2d3f = "spectrum-Field-contextualHelp_d2db1f";
$cd231e464c886c86$export$9ba23707a252cdd4 = "spectrum-Field--hasContextualHelp_d2db1f";
$cd231e464c886c86$export$94d2bcc94afabd89 = "spectrum-Form_d2db1f";
$cd231e464c886c86$export$7f44db659563c8f4 = "spectrum-Form--positionSide_d2db1f";
$cd231e464c886c86$export$9cde5aecff012641 = "spectrum-Field-labelCell_d2db1f";
$cd231e464c886c86$export$a872a8c78b26c9e0 = "spectrum-Field-labelWrapper_d2db1f";
$cd231e464c886c86$export$11b8bc81fe551057 = "spectrum-Form--positionTop_d2db1f";
$cd231e464c886c86$export$79f9a5e9dd010c8d = "spectrum-LabeledValue_d2db1f";
$cd231e464c886c86$export$51ec27881a1e3928 = "spectrum-Form-itemLabel_d2db1f";
$cd231e464c886c86$export$d35bc1e505d1ebbf = "is-disabled_d2db1f";
function $00af9ba397a66f43$var$Label(props, ref) {
  props = $6WzO6$useProviderProps(props);
  var _props = props,
    children = _props.children,
    _props$labelPosition = _props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'top' : _props$labelPosition,
    _props$labelAlign = _props.labelAlign,
    labelAlign = _props$labelAlign === void 0 ? labelPosition === 'side' ? 'start' : null : _props$labelAlign,
    isRequired = _props.isRequired,
    _props$necessityIndic = _props.necessityIndicator,
    necessityIndicator = _props$necessityIndic === void 0 ? isRequired != null ? 'icon' : null : _props$necessityIndic,
    _props$includeNecessi = _props.includeNecessityIndicatorInAccessibilityName,
    includeNecessityIndicatorInAccessibilityName = _props$includeNecessi === void 0 ? false : _props$includeNecessi,
    htmlFor = _props.htmlFor,
    labelFor = _props.for,
    _props$elementType = _props.elementType,
    ElementType = _props$elementType === void 0 ? 'label' : _props$elementType,
    onClick = _props.onClick,
    otherProps = _objectWithoutProperties(_props, _excluded);
  var domRef = $6WzO6$useDOMRef(ref);
  var _$6WzO6$useStyleProps2 = $6WzO6$useStyleProps(otherProps),
    styleProps = _$6WzO6$useStyleProps2.styleProps;
  var stringFormatter = $6WzO6$useLocalizedStringFormatter( /*@__PURE__*/$parcel$interopDefault($79b4ff1b6ea94ffc$exports));
  var necessityLabel = isRequired ? stringFormatter.format('(required)') : stringFormatter.format('(optional)');
  var icon = /*#__PURE__*/$6WzO6$react.createElement($6WzO6$spectrumiconsuiAsterisk, {
    UNSAFE_className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-FieldLabel-requiredIcon'),
    "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format('(required)') : undefined
  });
  var labelClassNames = $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-FieldLabel', {
    'spectrum-FieldLabel--positionSide': labelPosition === 'side',
    'spectrum-FieldLabel--alignEnd': labelAlign === 'end'
  }, styleProps.className);
  return /*#__PURE__*/$6WzO6$react.createElement(ElementType, _objectSpread(_objectSpread(_objectSpread({}, $6WzO6$filterDOMProps(otherProps)), styleProps), {}, {
    onClick: onClick,
    ref: domRef,
    className: labelClassNames,
    htmlFor: ElementType === 'label' ? labelFor || htmlFor : undefined
  }), children, (necessityIndicator === 'label' || necessityIndicator === 'icon' && isRequired) && " \u200B", necessityIndicator === 'label' && /*#__PURE__*/$6WzO6$react.createElement("span", {
    "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
  }, necessityLabel), necessityIndicator === 'icon' && isRequired && icon);
}
var $00af9ba397a66f43$export$b04be29aa201d4f5 = /*#__PURE__*/$6WzO6$react.forwardRef($00af9ba397a66f43$var$Label);
function $b7ca5b4454a2009d$var$Field(props, ref) {
  var formProps = $6WzO6$useFormProps(props);
  var isInForm = formProps !== props;
  props = formProps;
  var _props2 = props,
    label = _props2.label,
    _props2$labelPosition = _props2.labelPosition,
    labelPosition = _props2$labelPosition === void 0 ? 'top' : _props2$labelPosition,
    labelAlign = _props2.labelAlign,
    isRequired = _props2.isRequired,
    necessityIndicator = _props2.necessityIndicator,
    includeNecessityIndicatorInAccessibilityName = _props2.includeNecessityIndicatorInAccessibilityName,
    validationState = _props2.validationState,
    description = _props2.description,
    errorMessage = _props2.errorMessage,
    isDisabled = _props2.isDisabled,
    showErrorIcon = _props2.showErrorIcon,
    contextualHelp = _props2.contextualHelp,
    children = _props2.children,
    labelProps = _props2.labelProps,
    _props2$descriptionPr = _props2.descriptionProps,
    descriptionProps = _props2$descriptionPr === void 0 ? {} : _props2$descriptionPr,
    _props2$errorMessageP = _props2.errorMessageProps,
    errorMessageProps = _props2$errorMessageP === void 0 ? {} : _props2$errorMessageP,
    elementType = _props2.elementType,
    wrapperClassName = _props2.wrapperClassName,
    _props2$wrapperProps = _props2.wrapperProps,
    wrapperProps = _props2$wrapperProps === void 0 ? {} : _props2$wrapperProps,
    otherProps = _objectWithoutProperties(_props2, _excluded2);
  var _$6WzO6$useStyleProps3 = $6WzO6$useStyleProps(otherProps),
    styleProps = _$6WzO6$useStyleProps3.styleProps;
  var hasHelpText = !!description || errorMessage && validationState === 'invalid';
  var mergedRefs = $b7ca5b4454a2009d$var$useMergeRefs(children.ref, ref);
  var contextualHelpId = $6WzO6$useId();
  if (label || hasHelpText) {
    var labelWrapperClass = $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field', {
      'spectrum-Field--positionTop': labelPosition === 'top',
      'spectrum-Field--positionSide': labelPosition === 'side',
      'spectrum-Field--alignEnd': labelAlign === 'end',
      'spectrum-Field--hasContextualHelp': !!props.contextualHelp
    }, styleProps.className, wrapperClassName);
    children = /*#__PURE__*/$6WzO6$react.cloneElement(children, $6WzO6$mergeProps(children.props, {
      className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field-field')
    }));
    var renderHelpText = function renderHelpText() {
      return /*#__PURE__*/$6WzO6$react.createElement($8e50676506611310$export$a67c0bc59081311a, {
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        description: description,
        errorMessage: errorMessage,
        validationState: validationState,
        isDisabled: isDisabled,
        showErrorIcon: showErrorIcon,
        gridArea: "helpText"
      });
    };
    var renderChildren = function renderChildren() {
      if (labelPosition === 'side') return /*#__PURE__*/$6WzO6$react.createElement($6WzO6$Flex, {
        direction: "column",
        UNSAFE_className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field-wrapper')
      }, children, hasHelpText && renderHelpText());
      return /*#__PURE__*/$6WzO6$react.createElement($6WzO6$react.Fragment, null, children, hasHelpText && renderHelpText());
    };
    var labelAndContextualHelp = /*#__PURE__*/$6WzO6$react.createElement($6WzO6$react.Fragment, null, label && /*#__PURE__*/$6WzO6$react.createElement($00af9ba397a66f43$export$b04be29aa201d4f5, _objectSpread(_objectSpread({}, labelProps), {}, {
      labelPosition: labelPosition,
      labelAlign: labelAlign,
      isRequired: isRequired,
      necessityIndicator: necessityIndicator,
      includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
      elementType: elementType
    }), label), label && contextualHelp && /*#__PURE__*/$6WzO6$react.createElement($6WzO6$SlotProvider, {
      slots: {
        actionButton: {
          UNSAFE_className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field-contextualHelp'),
          id: contextualHelpId,
          'aria-labelledby': (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) ? "".concat(labelProps.id, " ").concat(contextualHelpId) : undefined
        }
      }
    }, contextualHelp));
    // Need to add an extra wrapper for the label and contextual help if labelPosition is side,
    // so that the table layout works inside forms.
    if (isInForm && labelPosition === 'side' && label && contextualHelp) labelAndContextualHelp = /*#__PURE__*/$6WzO6$react.createElement("div", {
      className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field-labelCell')
    }, /*#__PURE__*/$6WzO6$react.createElement("div", {
      className: $6WzO6$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Field-labelWrapper')
    }, labelAndContextualHelp));
    return /*#__PURE__*/$6WzO6$react.createElement("div", _objectSpread(_objectSpread(_objectSpread({}, styleProps), wrapperProps), {}, {
      ref: ref,
      className: labelWrapperClass
    }), labelAndContextualHelp, renderChildren());
  }
  return /*#__PURE__*/$6WzO6$react.cloneElement(children, $6WzO6$mergeProps(children.props, _objectSpread(_objectSpread(_objectSpread({}, styleProps), wrapperProps), {}, {
    ref: mergedRefs
  })));
}
function $b7ca5b4454a2009d$var$useMergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return $6WzO6$useCallback($6WzO6$mergeRefs.apply(void 0, refs), [].concat(refs));
}
var $b7ca5b4454a2009d$export$a455218a85c89869 = /*#__PURE__*/$6WzO6$react.forwardRef($b7ca5b4454a2009d$var$Field);
export { $b7ca5b4454a2009d$export$a455218a85c89869 as Field, $00af9ba397a66f43$export$b04be29aa201d4f5 as Label, $8e50676506611310$export$a67c0bc59081311a as HelpText };